import React, { Fragment } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";

import { renderWithBreaks } from '@utils/translations';
import styles from "@components/contractTypesPage/calendars/calendarContract.module.scss";

const CalendarFortnightlyFirst = () => {
  const intl = useIntl();

  return (
    <Fragment>
      {renderWithBreaks(intl.formatMessage({ id: 'Contract Type Monthly text' }))}
      <h3>{intl.formatMessage({ id: 'Example:' })}</h3>
      <div className={styles.calendarContract}>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'January'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'February'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
          <FormattedMessage id={'march'} />
          <span className={styles.calendarContract__moveDate} style={{right: "35%"}}>
            <FormattedMessage id={'Move in'} />: <strong>20 <FormattedMessage id={'March'} /></strong>
          </span>
          <span className={styles.calendarContract__contractDate} style={{right: "100%"}}>
            <FormattedMessage id={'Contract start'} />: <strong>1 <FormattedMessage id={'March'} /></strong>
          </span>
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
          <FormattedMessage id={'April'} />
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityBooked)}>
          <FormattedMessage id={'May'} />
          <span className={styles.calendarContract__moveDate} style={{right: "35%"}}>
            <FormattedMessage id={'Move_out'} />: <strong>20 <FormattedMessage id={'May'} /></strong>
          </span>
          <span className={styles.calendarContract__contractDate} style={{right: "0%"}}>
            <FormattedMessage id={'Contract_end'} />: <strong>31 <FormattedMessage id={'May'} /></strong>
          </span>
        </div>
        <div className={clsx(styles.calendarContract__availability, styles.calendarContract__availabilityNone)}>
          <FormattedMessage id={'June'} />
        </div>
      </div>
    </Fragment>
  );
};

export default CalendarFortnightlyFirst;
